<template>
    <div class="index">
        <div class="firstBox">
            <img src="@/assets/images/firstBox.png" alt="">   
            <img src="@/assets/images/videoMask.png" alt="" class="mask" @click="play" v-if="!playVideo">
            <video src="https://guanbo.oss-cn-shenzhen.aliyuncs.com/share_sys/ts1.m4v"  controls playsinline="true" webkit-playsinline="true" x5-playsinline="true" v-if="playVideo" ref="video"></video> 
        </div>
        <div class="secondBox">
            <img src="@/assets/images/secondBox.png" alt="">
            <Comment></Comment>
        </div>        
        <div class="thirdBox">
            <img src="@/assets/images/thirdBox.png" alt="">
        </div>        
        <div class="fourBox">
            <img src="@/assets/images/fourBox.png" alt="">
            <div class="button1"  @click="more('course')">了解更多</div>
        </div>        
        <div class="fiveBox">
            <img src="@/assets/images/fiveBox.png" alt="">
        </div>        
        <div class="sixBox">
            <img src="@/assets/images/sixBox.png" alt="">
            <div class="button2" @click="more('server')">了解更多</div>
        </div> 
        <div class="sevenBox">
            <img src="@/assets/images/sevenBox.png" alt="">
        </div>       
        <div class="eightBox">
            <img src="@/assets/images/eightBox.png" alt="">
        </div>       
        <div class="nineBox">
            <img src="@/assets/images/nineBox.png" alt="">
        </div>       
        <div class="tenBox">
            <img src="@/assets/images/cooperationBg.png" alt="">
            <img src="@/assets/images/medias.png" alt="" class="medias">
            <img src="@/assets/images/mediaReportOne.png" alt="" class="mediaReportOne" @click="goDetails(1)">
        </div>       
        <div class="elevenBox">
            <img src="@/assets/images/cooperationBgTwo.png" alt="">
            <img src="@/assets/images/mediaReportTwo.png" alt="" class="mediaReportTwo" @click="goDetails(2)">
            <img src="@/assets/images/mediaReportThree.png" alt="" class="mediaReportThree" @click="goDetails(3)">
        </div>       
        <div class="twelveBox">
            <img src="@/assets/images/cooperationBgThird.png" alt="">
            <img src="@/assets/images/mediaReportFour.png" alt="" class="mediaReportFour" @click="goDetails(4)">
        </div>       
    </div>
</template>

<script type="text/ecmascript-6">
import Comment from '@/components/Comment.vue'
export default {
 components: {
    Comment
},
 props: {},
 data () {
     return {
        playVideo:false,
     };
 },
 watch: {},
 computed: {},
 methods: {
    play(){
        this.playVideo = true
        let _this = this
        setTimeout(function(){
            _this.$refs.video.play()
        },100)
        
    },
    goDetails(id){
        console.log(id)
        if(id == 1){
            window.location.href = 'https://www.sohu.com/a/247658043_120074'
        }else if(id == 2){
            window.location.href = 'https://lx.huanqiu.com/article/9CaKrnKlip1'
        }else if(id == 3){
            window.location.href = 'https://dy.163.com/article/E47CBCM30512FCB3.html?referFrom='
        }else if(id == 4){
            window.location.href = 'https://m.jiemian.com/article/3092581.html'
        }
    },
    more(str){
        if(str == 'course'){
            this.$router.push({
                path:'/course'
            })
        }else{
            this.$router.push({
                path:'/serve'
            })
        }
    }
},
 mounted () {}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue